var o=function(){return"v2-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12)};export{o as generateUniqueID};
